export * from './app.component';
export * from './app.module';



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/_storageApp.Front.release/src/app/index.ts